import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "@/lib/api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: (tentativa, erro) => {
        // 4xx é erro de contrato/permissão: repetir não muda o resultado.
        if (erro instanceof ApiError && erro.status < 500) return false;
        return tentativa < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

/** Bases de referência mudam raramente — ficam frescas por bem mais tempo. */
export const TEMPO_REFERENCIA = 30 * 60_000;
